import PropTypes from 'prop-types'
import * as S from './styles'

const AlertBox = ({ message, id, isHexaHeader }) => {
  return (
    <S.BoxWrapper isHexaHeader={isHexaHeader} id={id}>
      {message}
    </S.BoxWrapper>
  )
}

AlertBox.propTypes = {
  id: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  isHexaHeader: PropTypes.bool,
}

export default AlertBox
